// extracted by mini-css-extract-plugin
export default {"wraper":"SendedEmail_wraper__1JewU","text":"SendedEmail_text__xe+fI","close":"SendedEmail_close__ucmgr"};